import styled from 'styles/styled';

export const MobileBelt = styled.div`
  @media (min-width: 1021px) {
    display: none;
  }
`;

export const Box = styled.div`
  background-color: #15191E;
  border-radius: 0 0 10px 10px;
  padding: 12px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  z-index: 30;
  @media (max-width: 720px) {
    flex: 0 0 auto;
    padding: 0;
    margin-bottom: 0;
    border-radius: 0;
  }
`;

export const Wrap = styled.div`
  padding: 0 14px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  position: relative;
  @media (max-width: 720px) {
    padding: 0;
    flex: 0 0 auto;
  }
  .hide_mobile {
    display: none;
  }
`;

export const GraphWrapper = styled.div`
  width: 100%;
  border: 1px solid #292B2E;
  border-radius: 8px;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 240px;

  @media (max-width: 720px) {
    flex: 0 0 auto;
    height: 260px;
    min-height: 220px;
  }

  &.Margin {
    @media (max-width: 720px) {
      flex: 0 0 auto;
      min-height: 200px;
      height: 240px;
      body.mobile-limit-active & {
        min-height: 180px;
        height: 200px;
      }
    }
  }
`;
